import React from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '@iconify/react';
import MenuWidget from '../Widget/MenuWidget';
import NewsLetterWidget from '../Widget/NewsLetterWidget';

const menuData = [
  { title: 'Accueil', href: '/' },
  { title: 'À Propos', href: '/about' },
  { title: 'Services', href: '/service' },
  { title: 'Contact', href: '/contact' },
];

export default function Footer() {
  return (
    <footer className="cs_footer text-white">
      <div className="container">
        <div className="cs_footer_main cs_pt_60 cs_pb_60">
          <div className="row">
            <div className="col-lg-3 col-md-6 cs_mb_lg_40">
              <div className="cs_footer_item">
                <Link className="cs_footer_branding d-inline-block cs_mb_25" to="/">
                  <img src="/images/logo.png" alt="Nexting Études — Bureau d'études en ingénierie du bâtiment à Tunis" />
                </Link>
                <div className="cs_social_btns d-flex flex-wrap cs_column_gap_15 cs_row_gap_15 cs_transition_5">
                  <Link
                    to="/"
                    className="d-flex align-items-center justify-content-center cs_height_35 cs_width_35 text-white rounded-circle"
                    aria-label="Facebook"
                  >
                    <Icon icon="fa6-brands:facebook-f" />
                  </Link>
                  <Link
                    to="/"
                    className="d-flex align-items-center justify-content-center cs_height_35 cs_width_35 text-white rounded-circle"
                    aria-label="LinkedIn"
                  >
                    <Icon icon="fa6-brands:linkedin-in" />
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 cs_mb_lg_40">
              <div className="cs_footer_item cs_pt_20 cs_pb_20">
                <div className="cs_text_widget">
                  <p>
                    Bureau d&apos;études spécialisé en ingénierie du bâtiment,
                    études techniques et suivi de chantier. Nous accompagnons vos
                    projets de construction avec rigueur, innovation et expertise,
                    de la conception à la réalisation.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-2 col-md-6 cs_mb_lg_40">
              <MenuWidget
                data={menuData}
                title="Liens Utiles"
                singleColumn
              />
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="cs_footer_item cs_pt_20 cs_pb_20">
                <NewsLetterWidget
                  title="Newsletter"
                  subTitle="Restez informé de nos projets et actualités"
                  placeholder="Votre adresse mail"
                  buttonText="Envoyer"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
